import React, {ReactNode} from 'react';

import {
  modalCloseButton,
  modalContent,
  modalHeader,
  modalHeaderHeading,
  modalHeaderImage,
  modalWrapper,
} from '#Client/components/Modal/Modal.css';
import {Close} from '#Client/images/Close';

type ModalProps = {
  image: string;
  title: string;
  children: ReactNode;
  onClose: () => void;
};

export const Modal = ({children, image, title, onClose}: ModalProps) => (
  <div className={modalWrapper}>
    <div className={modalHeader}>
      <h2 className={modalHeaderHeading}>
        <img className={modalHeaderImage} height="64" src={image} width="64" />
        <span>{title}</span>
      </h2>
      <Close className={modalCloseButton} onClick={onClose} />
    </div>
    <div className={modalContent}>{children}</div>
  </div>
);
